import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import Header from "../../../Header/Header";
import SideBar from "../../../SideBar/SideBar";
import Footer from "../../../Footer/Footer";
import { allqueries, cancelled, resolved, pending } from "../../../imagepath";
import { useForm, Controller } from "react-hook-form";
import { InboxOutlined, UploadOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import { uploadWriteToUs } from "../../../HttpRequest/writetous";

const Writetous = () => {
  const [userdata, setuserdata] = useState({
    profileData: {},
  });
  const { handleSubmit, control, setValue, watch } = useForm();
  const userId = localStorage.getItem("id");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [files, setFiles] = useState([]);
  const [quarry, setQuarry] = useState({
    "id": 0,
    "query": "",
    "image": [],
    "status": "",
    "createdDate": new Date(), 
    "userId": 0
  });
  

  console.log(userdata);

  const handleWriteClick = async () => {
    console.log("form data-->", files);
    if (files && files.length > 0) {
      try {
        const responses = await Promise.all(
          files.map(async (file) => {
            console.log("file data", file);
            let formData = new FormData();
            formData.append("file", file);
            // try {
            //   const response = await uploadWriteToUs(userId, formData);
            //   console.log("Upload response:", response);
            //   return response;
            // } catch (uploadError) {
            //   console.error("Error during file upload:", uploadError);
            //   return { error: uploadError };
            // }
          })
        );
        console.log("All document uploads completed!", responses);
      } catch (error) {
        console.error("Error during file uploads:", error);
      }
    } else {
      console.warn("No files to upload");
    }
  };
  
  const handleChange = (event) => {
    setValue("queryfiledinput", event.target.value);
    setIsSubmitDisabled(!event.target.value);
  };
  // const uploadDocuments = async (files) => {
  //   try {
  //     let formData = new FormData();
  //     console.log("files in the upload method -->", files);
  //     files.forEach((file) => {
  //       formData.append("file", file);
  //     });
  //     const response = await uploadWriteToUs(userId, formData);
  //     return response;
  //   } catch (error) {
  //     return error;
  //   }
  // };
  const onFileChange = (info) => {
    console.log("files", info.fileList);
    setFiles(info.fileList);
    console.log("files after setfiles-->>", files);
    // setIsSubmitDisabled(
    //   !(info.target.value && watch("file") && watch("file").length > 0)
    // );
  };

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Sidebar */}
        <SideBar />

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Write To Us </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admindashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">ongoing Deals</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="student-group-form">
              <div className="row">
                <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card w-100 inovices-card">
                    <div className="card-body">
                      <div className="inovices-widget-header">
                        <span className="inovices-widget-icon">
                          <img src={allqueries} alt="" className="queyImage" />
                        </span>
                        <div className="inovices-dash-count">
                          <div className="inovices-amount">10</div>
                        </div>
                      </div>
                      <p className="inovices-all">
                        All Queries <span></span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card w-100 inovices-card">
                    <div className="card-body">
                      <div className="inovices-widget-header">
                        <span className="inovices-widget-icon">
                          <img src={resolved} alt="" className="queyImage" />
                        </span>
                        <div className="inovices-dash-count">
                          <div className="inovices-amount">5</div>
                        </div>
                      </div>
                      <p className="inovices-all">
                        Resolved Queries <span></span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card w-100 inovices-card">
                    <div className="card-body">
                      <div className="inovices-widget-header">
                        <span className="inovices-widget-icon">
                          <img src={cancelled} alt="" className="queyImage" />
                        </span>
                        <div className="inovices-dash-count">
                          <div className="inovices-amount">3</div>
                        </div>
                      </div>
                      <p className="inovices-all">
                        Cancelled Queries <span></span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-sm-6 col-12">
                  <div className="card w-100 inovices-card">
                    <div className="card-body">
                      <div className="inovices-widget-header">
                        <span className="inovices-widget-icon">
                          <img src={pending} alt="" className="queyImage" />
                        </span>
                        <div className="inovices-dash-count">
                          <div className="inovices-amount pull-left">2</div>
                        </div>
                      </div>
                      <p className="inovices-all">
                        Pending Queries <span></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card w-100">
                  <div className="card-body">
                    {/* Page Header */}
                    <div className="page-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <h3 className="page-title">Write A Query</h3>
                        </div>
                      </div>
                    </div>
                    {/* /Page Header */}

                    <div className="row col-12">
                      <div className="col-12 col-sm-6 mt-2">
                        <form onSubmit={handleSubmit(handleWriteClick)}>
                          <div className="form-group local-forms">
                            <label>
                              Write A query
                              <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="queryfiledinput"
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                <textarea
                                  {...field}
                                  className="form-control"
                                  onChange={(info) => {
                                    handleChange(info);
                                  }}
                                />
                              )}
                            />
                          </div>
                          <Controller
                            name="file"
                            control={control}
                            defaultValue={[]}
                            render={({ field }) => (
                              <Dragger
                                onChange={(info) => {
                                  onFileChange(info);
                                }}
                                beforeUpload={() => false}
                              >
                                <p className="ant-upload-drag-icon">
                                  <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">
                                  Click or drag file to this area to upload
                                </p>
                                <p className="ant-upload-hint">
                                  Support for a single or bulk upload.
                                </p>
                                <input
                                  type="file"
                                  style={{ display: "none" }}
                                />
                              </Dragger>
                            )}
                          />
                          <div className="row col-12 mt-2">
                            <button
                              className="btn btn-primary col-md-3 mx-3"
                              type="submit"
                              disabled={isSubmitDisabled}
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default Writetous;
